import clsx from 'clsx'
import PropTypes from 'prop-types'

import { Grid, Paper, Typography, Alert } from '@mui/material'

import { CODE_VALIDATION_FN } from '../../common/constants'
import useTranslations from '../../i18n/useTranslations'
import SearchFieldNotDummy from '../../ui/components/searchFieldNotDummy'
import useStyles from './styles'

const SearchCard = ({ onSearch, showNotFoundWarning }) => {
  const classes = useStyles()
  const t = useTranslations()

  return (
    <Grid item xs={12} md={6}>
      <Paper className={clsx(classes.paper, classes.paperShipmentLocator)}>
        <Typography
          variant="h2"
          className={clsx('secondaryTitle', 'decorator')}
        >
          {t('home:shipment-locator')}
        </Typography>
        <Typography className={classes.shippingSubtitle}>
          {t('home:shipment-locator-subtitle')}
        </Typography>
        <div className={classes.paperContent}>
          <div className={classes.shippingContent}>
            <SearchFieldNotDummy
              id="shippingCode"
              className={classes.shippingInput}
              helperText={t('home:shipment-locator-input-helper')}
              placeholder={t('home:shipment-locator-input-placeholder')}
              onSearch={onSearch}
              isButtonDisabledValidation={CODE_VALIDATION_FN}
              showClearIcon
              showSearchIcon
              showButton
            />
          </div>
        </div>
        <Alert
          severity="warning"
          aria-hidden={showNotFoundWarning ? null : true}
          sx={{
            opacity: showNotFoundWarning ? 1 : 0,
            pointerEvents: showNotFoundWarning ? 'inherit' : 'none',
          }}
        >
          <Typography variant="body2">{t('home:no-results')}</Typography>
        </Alert>
      </Paper>
    </Grid>
  )
}

SearchCard.propTypes = {
  onSearch: PropTypes.func,
  showNotFoundWarning: PropTypes.bool,
}

export default SearchCard
